import NewSignUps from './NewSignUps';

export default NewSignUps;
